import React from 'react';
import { Link } from 'react-router-dom';

const FeaturesSectionS2 = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className={'' + props.hclass}>
      <div className='top-wraper'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-6 col-12'>
              <div className='wpo-section-title'>
                <h2>Trusted logistics services</h2>
                <h3>Logistics features that we provide</h3>
              </div>
            </div>
            <div className='col-lg-6 col-12'>
              <div className='f-btn'>
                <Link
                  onClick={ClickHandler}
                  to='/services'
                  className='theme-btn'
                >
                  All Services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bottom-wraper'>
        <div className='container'>
          <div className='bottom-content'>
            <div className='row'>
              <div className='col-lg-4 col-12'>
                <div className='item'>
                  <div className='icon'>
                    <i className='flaticon-logistics'></i>
                  </div>
                  <div className='content'>
                    <h3>Freight Forwarding</h3>
                    <p>
                      Coordinated ocean, air, and road movements under one
                      operations team.
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-lg-4 col-12'>
                <div className='item'>
                  <div className='icon'>
                    <i className='flaticon-customer-support-1'></i>
                  </div>
                  <div className='content'>
                    <h3>24/7 Shipment Support</h3>
                    <p>
                      Round-the-clock shipment coordination with tracking
                      updates.
                    </p>
                  </div>
                </div>
              </div>
              <div className='col-lg-4 col-12'>
                <div className='item'>
                  <div className='icon'>
                    <i className='flaticon-fast-delivery-1'></i>
                  </div>
                  <div className='content'>
                    <h3>Priority Delivery Planning</h3>
                    <p>
                      Transit planning with milestone alerts to keep urgent
                      cargo on schedule.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSectionS2;
